"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturesContext = exports.FeaturesProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const constants_1 = require("./constants");
// Context
const FeaturesContext = (0, react_1.createContext)(constants_1.baseFeaturesContext);
exports.FeaturesContext = FeaturesContext;
// Component
const FeaturesProvider = ({ children }) => {
    const { data: globalConfig } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1FeatureFlagsGlobalQuery)();
    return ((0, jsx_runtime_1.jsx)(FeaturesContext.Provider, { value: { globalConfig }, children: children }));
};
exports.FeaturesProvider = FeaturesProvider;
